module.exports = __webpack_public_path__ + "img/wp-new-habit-card25.82423980.png";